module.exports = {
      id: "login-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "images/sprites__pch--7b5afc0570cf41d5312c5fb267e8afd5.svg#login-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__pch/sprites/login.svg
// module id = /tool/node_modules/svg-sprite-loader/lib/loader.js??ref--16-0!/tool/project/client/src/site__pch/sprites/login.svg
// module chunks = site__pch